angular.module('bribac.services.paths', [])

  .factory('paths', function() {
    var prefix = '!'

    return {
      HOME: '/',
      PROFILE: '/profile',
      LOGIN: '/login',

      getPrefix: function() {
        return prefix
      },

      get: function(path) {
        return '#' + prefix + path
      }
    }
  })
